<template>
  <v-data-table
    :loading="loading"
    disable-sort
    :headers="headers"
    :page.sync="currentPage"
    :items="items"
    :server-items-length="count"
    @update:options="(pagination) => onPageChange(pagination)"
    class="has-border"
  >
    <template v-slot:item="props">
      <tr>
        <td>
          <BaseTitleTable>{{
            props.item.student && props.item.student.name
              ? props.item.student.name
              : $vuetify.lang.t("$vuetify.TEXT_NOT_NAME")
          }}</BaseTitleTable>
        </td>
        <td>{{ dayjs(props.item.createdAt).format("DD/MM/YYYY") }}</td>
        <td>{{ generateDiscountTitle(props.item) }}</td>
        <td>
          {{
            `${
              props.item.isUseAffiliate
                ? $vuetify.lang.t("$vuetify.TEXT_YES")
                : $vuetify.lang.t("$vuetify.TEXT_NO")
            }`
          }}
        </td>
        <td>
          {{
            `${(props.item.rootPrice || 0).toLocaleString()}${$vuetify.lang.t(
              "$vuetify.USER_MANAGE.TEACHER_SALE.TEXT_CURRENT_UNIT"
            )}`
          }}
        </td>
        <td>
          {{
            `${props.item.price.toLocaleString()}${$vuetify.lang.t(
              "$vuetify.USER_MANAGE.TEACHER_SALE.TEXT_CURRENT_UNIT"
            )}`
          }}
        </td>
      </tr>
    </template>
  </v-data-table>
</template>
<script>
import dayjs from "dayjs";
export default {
  props: {
    items: Array,
    loading: Boolean,
    count: Number,
  },
  data() {
    return {
      dayjs,
      currentPage: 1,
      headers: [
        {
          text: this.$vuetify.lang.t("$vuetify.USER_MANAGE.TEACHER_SALE.TH_BUYER"),
          width: "15%",
        },
        {
          text: this.$vuetify.lang.t("$vuetify.USER_MANAGE.TEACHER_SALE.TH_CREATE_AT"),
          width: "15%",
        },
        {
          text: this.$vuetify.lang.t("$vuetify.USER_MANAGE.TEACHER_SALE.TH_CODE_TYPE"),
          width: "25%",
        },
        {
          text: this.$vuetify.lang.t("$vuetify.USER_MANAGE.TEACHER_SALE.TH_AFFILIATE"),
          width: "10%",
        },
        {
          text: this.$vuetify.lang.t(
            "$vuetify.USER_MANAGE.TEACHER_SALE.TH_BEFORE_DISCOUNT"
          ),
          width: "15%",
        },
        {
          text: this.$vuetify.lang.t("$vuetify.USER_MANAGE.TEACHER_SALE.TH_TOTAL_PRICE"),
          width: "15%",
        },
      ],
    };
  },
  methods: {
    resetCurrentPage() {
      this.currentPage = 1;
    },
    onPageChange(pagination) {
      this.$emit("onPageChange", {
        skip: pagination.page - 1,
        limit: pagination.itemsPerPage,
      });
    },
    generateDiscountTitle(item) {
      let listUsed = [];
      if (item.isUseCoupon) listUsed.push("Coupon");
      if (item.isUseCombo) listUsed.push("Combo");
      if (item.isUseActiveCode) listUsed.push("Mã kích hoạt");
      return listUsed.length
        ? listUsed.join(",")
        : this.$vuetify.lang.t("$vuetify.TEXT_NO");
    },
    displayState(state) {
      if (state === "success") {
        return this.$vuetify.lang.t("$vuetify.USER_MANAGE.TEACHER_SALE.TEXT_SUCCESS");
      } else if (state === "pending") {
        return this.$vuetify.lang.t("$vuetify.USER_MANAGE.TEACHER_SALE.TEXT_WAITING");
      } else {
        return this.$vuetify.lang.t("$vuetify.USER_MANAGE.TEACHER_SALE.TEXT_FAIL");
      }
    },
  },
};
</script>
